import React, { useRef } from "react";
import NavigationDrawer from "../../components/navigationDrawer";
import BannerSection from "./BannerSection";
import RangeSection from "./RangeSection";
import ContactForm from "./ContactForm";
import BroadbandSection from "./BroadbandSection";
import PhoneOnlySection from "./PhoneOnlySection";
import PhoneLine from "./PhoneLine";
import BroadbandOnlySection from "./BroadbandOnlySection";
import HandsetsSection from "./HandsetsSection";
import PhoneBroadbandSection from "./PhoneBroadbandSection";
import TrustPilot from "./TrustPilot";
import ChatFloatingBtn from "../../components/chatFloatingBtn";
import { Box, Grid, Typography, useMediaQuery } from "@mui/material";
import { allColors } from "../../constants";
import { images } from "../../assets";
// import elephantSvg from "../../assets/images/elephant.svg";

const dataaaa = [
  {
    icon: images.searchImg,
    name: "No mid-contract price rises.",
    description: "It's in our contract.",
  },
  {
    icon: images.lockImg,
    name: "Relocating or Closing?",
    description:
      "If you're relocating or closing your business we won't charge you a penalty.",
  },
  {
    icon: images.giftBoxImg,
    name: "Plus, as a thank you for your loyalty.",
    description:
      "We will give exclusive discounts and promotions along the way.",
  },
];

const Home = () => {
  const openChatBoxRef = useRef(null);
  const isSmallScreen = useMediaQuery((theme) => theme.breakpoints.down("sm"));

  return (
    <NavigationDrawer>
      <Box
        sx={{
          width: "100%",
          marginTop: "40px",
          padding: "50px 0 25px",
          background: `url(${
            isSmallScreen
              ? images.loyaltyElephantMobileImg
              : images.loyaltyElephantImg
            // require("../../assets/images/elephant.svg").default
          })`,
          // background: {
          //   xs: `url(${images.loyaltyElephantMobileImg})`,
          //   sm: `url(${images.loyaltyElephantImg})`,
          // },
          backgroundSize: "cover",
          backgroundRepeat: "no-repeat",
          backgroundPosition: "center",
        }}
      >
        <Typography
          sx={{
            textAlign: "center",
            fontSize: { xs: "32px", sm: "50px" },
            // color: allColors.jetBlack,
            fontWeight: "800",
            fontFamily: "Raleway",
            margin: { xs: "30px 55px 10px", md: "0 0 10px" },
          }}
        >
          Loyalty is lost on our competitors.
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: "400",
            fontFamily: "Raleway",
            fontSize: { xs: "15px", sm: "19px" },
            margin: { xs: "0 55px 30px", md: "0 0 50px" },
          }}
        >
          Had enough of signing up to one price and paying another?
        </Typography>

        <Grid
          container
          spacing={4}
          textAlign={"center"}
          justifyContent={"center"}
          sx={{ marginBottom: { xs: "180px", md: "180px" } }}
        >
          {dataaaa.map((itemmmm) => {
            return (
              <Grid item xs={8} md={2}>
                <img
                  src={itemmmm.icon}
                  style={{
                    height: "50px",
                    width: "50px",
                    marginBottom: "5px",
                  }}
                />
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "600",
                    fontFamily: "Raleway",
                    fontSize: "18px",
                  }}
                >
                  {itemmmm.name}
                </Typography>
                <Typography
                  sx={{
                    textAlign: "center",
                    fontWeight: "300",
                    fontFamily: "Raleway",
                    fontSize: { xs: "14px", sm: "16px" },
                  }}
                >
                  {itemmmm.description}
                </Typography>
              </Grid>
            );
          })}
        </Grid>

        <Typography
          sx={{
            textAlign: "center",
            fontWeight: "600",
            color: allColors.white,
            fontFamily: "Raleway",
            fontSize: { xs: "16px", sm: "20px" },
            display: { xs: "none", md: "block" },
            lineHeight: "45px",
          }}
        >
          So when you join Trust Business, we don’t just deliver a service, we
          will support you every step of the way.
          <br />
          Like elephants, we simply don’t forget.
        </Typography>
        <Typography
          sx={{
            textAlign: "center",
            fontWeight: "600",
            color: allColors.white,
            fontFamily: "Raleway",
            fontSize: { xs: "15px", sm: "20px" },
            display: { xs: "block", md: "none" },
            margin: "0 30px",
          }}
        >
          So when you join Trust Business, we don’t just deliver a service, we
          will support you every step of the way.
          <br />
          <br />
          Like elephants, we simply don’t forget.
        </Typography>
      </Box>

      <BannerSection />
      <RangeSection />
      <PhoneOnlySection />
      <PhoneLine />
      <BroadbandSection />
      <BroadbandOnlySection />
      <HandsetsSection />
      <PhoneBroadbandSection />
      <ContactForm openChatBoxRef={openChatBoxRef} />
      {/* <AboutSection /> */}
      <TrustPilot />
      <ChatFloatingBtn openChatBoxRef={openChatBoxRef} />
    </NavigationDrawer>
  );
};

export default Home;
